import script from "./ProductTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ProductTemplate.vue?vue&type=style&index=0&id=c297795a&lang=scss&scoped=true"
import "./ProductTemplate.vue?vue&type=style&index=1&id=c297795a&lang=scss"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c297795a"]])

export default __exports__